import { useSelector } from "react-redux"
import { useEffect, useState, useCallback } from "react"
import { Link, useLocation } from "react-router-dom"

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import moment from "moment"
import { Model } from "../../../models/model"
import { DialogFormTask } from "../DialogFormTask"
import { Crear } from "../Crear"
import { Tooltip } from "@mui/material"
import { DetailTasks } from "./DetailTasks"
import { DialogFlowGeneral } from "../../pptos/form/flows/DialogFlowGeneral"
import { RowHito } from "./RowHito"
import { FiltersMoreOptions } from "../../general/buscadorTasks/FiltersMoreOptions"

const getPathName = (path) => {
    const arrayNames = path.split('/')
    return arrayNames[1]
};

export const TasksModeList = ({ origen }) => {

    const location = useLocation()
    const pathName = getPathName(location.pathname)
    const { usuariosTarea, detail } = useSelector(state => state.general)
    const { tarea_mostrar_horas } = detail

    const [openDialogFormTask, setOpenDialogFormTask] = useState(false)
    const [openDialogProjections, setOpenDialogProjections] = useState(false)
    // const [infoItemPpto, setInfoItemPpto] = useState({})
    // const [currentTasks, setCurrentTasks] = useState({})

    const [idSelected, setIdSelected] = useState(0)
    const [tasksList, setTasksList] = useState([])
    const [openAll, setOpenAll] = useState(false)

    const [filters, setFilters] = useState({
        id_ppto: origen.from === 'project' ? origen.id : null,
        view: 'list',
        id_responsable: 0,
        estado: '',
        programacion: ''
    })

    const handleGetTasks = useCallback(async (filters, checkOpen = false) => {
        const params = (new URLSearchParams(filters)).toString()
        const newTasksList = await Model.getAll({ url: `tasks/?${params}` })

        if (checkOpen) {
            // await handleOpenRefresh(tasksList, newTasksList)
        } else {
            setTasksList(newTasksList)
            setOpenAll(true)
        }
    }, [])

    useEffect(() => {
        handleGetTasks(filters)
    }, [filters, handleGetTasks, origen.reloadList])

    const handleOpenEdit = async (taskId) => {
        setIdSelected(taskId)
        setOpenDialogFormTask(true)
    }

    const handleFilters = ({ target }) => {
        setFilters(prev => ({
            ...prev,
            [target.name]: target.value
        }))
    }

    const handleRemoveTask = async (task) => {
        const tasksListUpdated = tasksList?.filter(it => it.id !== task.id)
        setTasksList(tasksListUpdated)

        if (task?.created) {
            await Model.delete({
                url: `tasks/proyectos/tasks2/${task.id}`
            })
        }

    }

    const handleUpdateNroOrder = (list) => {
        let count = 0
        const newList = list.map(it => {
            count++
            return {
                ...it,
                orden: count
            }
        })

        return newList
    }

    const handleChangeOrder = (list, startIndex, endIndex) => {
        const result = [...list]
        const [removed] = result.splice(startIndex, 1)
        result.splice(endIndex, 0, removed)
        const result2 = handleUpdateNroOrder(result)
        return result2
    }

    const handleDragEnd = async (result) => {
        const { source, destination } = result

        if (!destination) {
            return;
        }

        if (source.index === destination.index && source.droppableId === destination.droppableId) {
            return;
        }

        const tasksListOrdered = handleChangeOrder(tasksList, source.index, destination.index)
        setTasksList(tasksListOrdered)
        // console.log({ tasksListOrdered })

        await Model.update({
            url: `tasks/update-order-list/0`,
            dataForm: {
                tasks_new_order: tasksListOrdered
            }
        })

    }

    const handleOpenAll = () => {
        const newState = !openAll
        setOpenAll(newState)

        const newHitosListUpdated = tasksList.map(it => {

            const taskListUpdated = it.subs.map(task => {
                return {
                    ...task,
                    show_subs: newState ? true : false
                }
            })

            return {
                ...it,
                show_subs: newState ? true : false,
                subs: taskListUpdated
            }
        })

        setTasksList(newHitosListUpdated)

    }


    const handleOpenSubs = (taskId, hitoId) => {

        // hito
        const tasksListUpdated = tasksList.map(hito => {
            if (hito.id === hitoId) {

                // task
                const tasksListUpdated = hito.subs.map(task => {
                    if (task.id === taskId) {
                        return {
                            ...task,
                            show_subs: !task.show_subs
                        }
                    }

                    return task
                })

                return {
                    ...hito,
                    subs: tasksListUpdated
                }
            }

            return hito
        })

        setTasksList(tasksListUpdated)
    }

    const handleOpenEditFlow = async (itemTask) => {

        let itemPptoId = itemTask?.info_flow?.id_item_ppto || null
        // setCurrentTasks(itemTask)

        if (itemPptoId) {

            // const resultOneItemPpto = await Model.getOne({
            //     url: `budgets-items/${itemPptoId}`,
            // })

            // setInfoItemPpto(resultOneItemPpto)

        } else {

            let hitoId = 0

            if (itemTask.tipo === 'hito') {
                hitoId = itemTask.id
            }

            if (itemTask.tipo === 'task' || itemTask.tipo === 'subtask') {
                hitoId = itemTask.id_hito
            }

            const hitos = tasksList
            for (let h = 0; h < hitos.length; h++) {
                if (hitos[h].id === hitoId) {
                    itemPptoId = hitos[h]?.info_flow?.id_item_ppto || null

                    if (itemPptoId) {
                        break;
                    }

                    // sino busco en tareas
                    const tasks = hitos[h].subs
                    for (let t = 0; t < tasks.length; t++) {
                        itemPptoId = tasks[t]?.info_flow?.id_item_ppto || null

                        if (itemPptoId) {
                            break;
                        }

                        // sino busco en subtareas
                        const subTareas = tasks[t].subs
                        for (let st = 0; st < subTareas.length; st++) {
                            itemPptoId = subTareas[st]?.info_flow?.id_item_ppto || null

                            if (itemPptoId) {
                                break;
                            }
                        }


                    }

                }
            }

            // console.log({ itemPptoId })
            if (itemPptoId) {

                // const resultOneItemPpto = await Model.getOne({
                //     url: `budgets-items/${itemPptoId}`,
                // })

                // setInfoItemPpto(resultOneItemPpto)

            } else {

                // setInfoItemPpto({
                //     id: null,
                //     id_presupuesto: itemTask?.id_proyecto || null
                // })

            }

        }

        setOpenDialogProjections(true)
    }

    return (
        <>

            {openDialogFormTask &&
                <DialogFormTask
                    open={openDialogFormTask}
                    setOpen={setOpenDialogFormTask}
                    taskId={idSelected}
                    refreshObj={
                        {
                            fn_: handleGetTasks,
                            filters_: filters
                        }
                    }
                />
            }

            {openDialogProjections ?
                <DialogFlowGeneral
                    open={openDialogProjections}
                    setOpen={setOpenDialogProjections}
                    item={{ id: null }}
                    tasksList={[]}
                    currentTasks={{ id: null }}
                    refreshObj={() => false}
                /> : ''
            }

            <div className="flex justify-content-between align-items-center">
                <div>
                    <FiltersMoreOptions
                        filters={filters}
                        setFilters={() => false}
                        handleFilters={handleFilters}
                        pathName={pathName}
                        usuariosTarea={usuariosTarea}
                    />
                </div>
                <div>
                    <Tooltip title="Actualizar lista" placement="right">
                        <button
                            className='btn p-btn-secondary d-flex align-items-center'
                            onClick={() => handleGetTasks(filters)}
                        >
                            <i className="bi bi-arrow-clockwise"></i>
                            <label className="ms-1">Actualizar</label>
                        </button>
                    </Tooltip>
                </div>
                <div className="me-3">
                    <Crear
                        refreshObj={
                            {
                                fn_: handleGetTasks,
                                filters_: filters
                            }
                        }
                    />
                </div>
            </div>

            {(tasksList[0]?.fecha_inicio && tasksList[tasksList?.length - 1]?.fecha_fin) ?
                <div className="ms-2">
                    <span>
                        <label>Fecha Inicio:</label>
                        <span className="ms-1">{moment(tasksList[0]?.fecha_inicio).format('DD-MM-YYYY')}</span>
                    </span>
                    <span className="ms-2">
                        <label>Fecha Fin:</label>
                        <span className="ms-1">{moment(tasksList[tasksList?.length - 1]?.fecha_fin).format('DD-MM-YYYY')}</span>
                    </span>
                    <span className="ms-2">
                        ({moment(tasksList[tasksList?.length - 1]?.fecha_fin).diff(moment(tasksList[0]?.fecha_inicio), 'days') + 1} días)
                    </span>
                </div> : ''
            }

            {tarea_mostrar_horas ?
                <BoxHoras origen={origen} /> : ''
            }

            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="tasks-list-2">
                    {(droppableProvider) => (
                        <div
                            {...droppableProvider.droppableProps}
                            ref={droppableProvider.innerRef}
                            className="table-responsives animate__animated animate__fadeIn mt-3">
                            <table className="table table-sm table-hover ms-2 p-table-tasks">
                                <Thead
                                    tasksList={tasksList}
                                    openAll={openAll}
                                    handleOpenAll={handleOpenAll}
                                    pathName={pathName}
                                    tarea_mostrar_horas={tarea_mostrar_horas}
                                />
                                <tbody>
                                    {tasksList?.map((it, index) => (
                                        <Draggable key={it.id} draggableId={it.id} index={index}>
                                            {(draggableProvided) => (
                                                <>
                                                    <RowHito
                                                        it={it}
                                                        draggableProvided={draggableProvided}
                                                        handleOpenEdit={handleOpenEdit}
                                                        tasksList={tasksList}
                                                        setTasksList={setTasksList}
                                                        handleRemoveTask={handleRemoveTask}
                                                        usuariosTarea={usuariosTarea}
                                                        pathName={pathName}
                                                        handleOpenEditFlow={handleOpenEditFlow}
                                                        tarea_mostrar_horas={tarea_mostrar_horas}
                                                    />

                                                    {it?.show_subs ?
                                                        <DetailTasks
                                                            currentTask={it}
                                                            opens={{
                                                                handleOpenEdit: handleOpenEdit,
                                                                handleOpenEditFlow: handleOpenEditFlow,
                                                                handleOpenSubs: handleOpenSubs
                                                            }}
                                                            usuariosTarea={usuariosTarea}
                                                            handleRemoveTask={handleRemoveTask}
                                                            refreshObj={
                                                                {
                                                                    fn_: handleGetTasks,
                                                                    filters_: filters
                                                                }
                                                            }
                                                            pathName={pathName}
                                                            tarea_mostrar_horas={tarea_mostrar_horas}
                                                        /> : ''
                                                    }

                                                </>
                                            )}
                                        </Draggable>
                                    ))}
                                    {droppableProvider.placeholder}
                                </tbody>
                            </table>
                        </div >
                    )}
                </Droppable>
            </DragDropContext>

        </>
    )
}

const Thead = ({ tasksList, openAll, handleOpenAll, pathName, tarea_mostrar_horas }) => {

    return (
        <thead>
            <tr className="text-center">
                {pathName === 'tasks' ? <th scope="col" className="text-start">Proyecto</th> : ''}
                <th scope="col" colSpan={3} className="text-start">
                    <div className="d-flex justify-content-start">
                        <span>Tareas ({tasksList?.length || 0})</span>
                        {openAll ?
                            <Link to="#" className="ms-5" onClick={handleOpenAll}>
                                <i className="bi bi-caret-down-fill"></i>
                                <label className="ms-1" style={{ cursor: 'pointer' }}>Cerrar todo</label>
                            </Link>
                            :
                            <Link to="#" className="ms-5" onClick={handleOpenAll}>
                                <i className="bi bi-caret-right-fill"></i>
                                <label className="ms-1" style={{ cursor: 'pointer' }}>Abrir todo</label>
                            </Link>
                        }
                    </div>
                </th>
                <th scope="col">Responsable</th>
                <th scope="col">Seguimiento</th>
                {tarea_mostrar_horas ?
                    <>
                        <th scope="col" title="horas estimadas">HE</th>
                        <th scope="col" title="horas reales">HR</th>
                    </>
                    : ''
                }
                <th scope="col">Días</th>
                <th scope="col">F. Inicio</th>
                <th scope="col">F. Fin</th>
                <th scope="col">Estado</th>
                <th scope="col"></th>
            </tr>
        </thead>
    )
}

// const RowHito = ({ it, draggableProvided, handleOpenEdit, tasksList, setTasksList, handleRemoveTask, usuariosTarea, pathName, handleOpenEditFlow, tarea_mostrar_horas }) => {
//     return (
//         <tr
//             {...draggableProvided.draggableProps}
//             ref={draggableProvided.innerRef}
//             {...draggableProvided.dragHandleProps}
//             style={{
//                 verticalAlign: 'middle',
//                 color: it.estado === 'completado' ? 'green' : ''
//             }}>

//             {pathName === 'tasks' ?
//                 <td style={{ verticalAlign: 'middle' }}>
//                     <div style={{ width: '200px' }}>
//                         <Link
//                             className="p-link-project-name"
//                             target="_black"
//                             to={`/ppto/${it.id_proyecto}`}
//                         >
//                             {it.project_name}
//                         </Link>
//                     </div>
//                 </td> : ''
//             }

//             <td colSpan={3}
//                 style=
//                 {{
//                     verticalAlign: 'middle',
//                     width: '400px',
//                     height: '55px'
//                 }}>
//                 <div className="d-flex flex-column justify-content-center align-items-start">
//                     <div className="d-flex justify-content-between align-items-center"
//                         style={{
//                             width: '100%',
//                             border: 'none',
//                             color: (it?.tipo === 'hito' || it?.subs.length > 0) ? '#8E24AA' : '#78717A',
//                         }}>
//                         <Link
//                             to=""
//                             onClick={() => handleOpenEdit(it?.id)}
//                             // className={it.estado === 'completado' ? 'p-link-hitos-done' : 'p-link-hitos'}
//                             className={`d-flex justify-content-start align-items-center 
//                                 ${it.estado === 'completado' ? 'p-link-hitos-done' : 'p-link-hitos'}`}
//                         >
//                             <div style={{
//                                 fontSize: '14px',
//                                 textAlign: 'left',
//                                 // textDecoration: it.estado === 'completado' ? 'line-through' : '',
//                             }}>
//                                 {it?.prioridad === 'critica' ?
//                                     <span style={{ color: 'red' }}>
//                                         {`${it?.orden ? `(${it?.orden})` : ''} ${it?.tipo === 'hito' ? 'Hito: ' : ''} ${it.nombre}`}
//                                     </span>
//                                     :
//                                     <span>
//                                         {`${it?.orden ? `(${it?.orden})` : ''} ${it?.tipo === 'hito' ? 'Hito: ' : ''} ${it.nombre}`}
//                                     </span>
//                                 }
//                             </div>

//                             {it.estado === 'completado' ?
//                                 <Tooltip title="Hito completado">
//                                     <i className="bi bi-check-circle-fill ms-1" style={{ fontSize: '14px' }}></i>
//                                 </Tooltip> : ''
//                             }

//                         </Link>

//                         {(it.proyecccion_cant > 0 || it?.info_flow?.id_item_ppto) ?
//                             <Link
//                                 to=""
//                                 style={{ marginTop: '2px' }}
//                                 className="p-link-hitos ms-2 d-flex justify-content-start align-items-end"
//                                 onClick={() => handleOpenEditFlow(it)}
//                             >
//                                 <i className="bi bi-link-45deg" style={{ fontSize: '12px' }}></i>
//                                 flujo ({it.proyecccion_cant > 1 ? 'varios' : moment(it?.info_flow?.fecha_proyeccion).format('DD-MM-YYYY')})
//                             </Link>
//                             :
//                             // <Link
//                             //     to=""
//                             //     style={{ textDecoration: 'none' }}
//                             //     onClick={() => handleOpenEditFlow(it)}
//                             // >
//                             //     <i className="bi bi-link-45deg" style={{ fontSize: '12px' }}></i>
//                             //     <span style={{ textTransform: 'none', marginLeft: '2px' }}>Enlazar a flujo</span>
//                             // </Link>
//                             ''
//                         }

//                     </div>

//                     {it?.subs.length > 0 &&
//                         <Link to=""
//                             onClick={() => {
//                                 const listUpdated2 = tasksList.map(it2 => {
//                                     if (it2.id === it?.id) {
//                                         return {
//                                             ...it2,
//                                             show_subs: !it2.show_subs
//                                         }
//                                     }

//                                     return it2
//                                 })

//                                 setTasksList(listUpdated2)
//                             }}
//                             className="d-flex align-items-start d-flex align-items-center p-link-info-task">
//                             <i className="bi bi-list-check ms-1" style={{ fontSize: '16px' }}></i>
//                             <span style={{ fontSize: '12px', marginLeft: '2px' }}>
//                                 {it?.subs.length} {`${it?.tipo === 'hito' ? `${it?.subs.length === 1 ? 'tarea' : 'tareas'}` : `${it?.subs.length === 1 ? 'subtarea' : 'subtareas'}`}`}
//                             </span>
//                         </Link>
//                     }

//                 </div>
//             </td>
//             <td className="text-center">
//                 {/* {(usuariosTarea.find(ut => ut.id === it?.id_responsable))?.nombre || ''} */}
//             </td>
//             <td className="text-center">
//                 {/* {(usuariosTarea.find(ut => ut.id === it?.id_responsable_seguimiento))?.nombre || ''} */}
//             </td>

//             {tarea_mostrar_horas ?
//                 <>
//                     <td className="text-center">
//                         <NumberFormat
//                             displayType={'text'}
//                             className="text-end"
//                             value={it.hora_estimada || 0}
//                             thousandSeparator=','
//                             decimalSeparator='.'
//                             suffix=" hrs."
//                             decimalScale={0}
//                             fixedDecimalScale={0}
//                         />
//                     </td>
//                     <td className="text-center">
//                         <NumberFormat
//                             displayType={'text'}
//                             className="text-end"
//                             value={it.hora_real || 0}
//                             thousandSeparator=','
//                             decimalSeparator='.'
//                             suffix=" hrs."
//                             decimalScale={0}
//                             fixedDecimalScale={0}
//                         />
//                     </td>
//                 </>
//                 : ''
//             }

//             <td className="text-center">
//                 {it?.subs?.length > 0 ?
//                     // <span>{it?.fecha_fin ? moment(it?.fecha_fin).diff(moment(it?.fecha_inicio), 'days') : 0} Días</span>
//                     <NumberFormat
//                         displayType={'text'}
//                         className="text-end"
//                         value={it.dias || 0}
//                         thousandSeparator=','
//                         decimalSeparator='.'
//                         suffix=" días"
//                         decimalScale={0}
//                         fixedDecimalScale={0}
//                     />
//                     :
//                     <NumberFormat
//                         displayType={'text'}
//                         className="text-end"
//                         value={it.dias || 0}
//                         thousandSeparator=','
//                         decimalSeparator='.'
//                         suffix=" días"
//                         decimalScale={0}
//                         fixedDecimalScale={0}
//                     />
//                 }
//             </td>
//             <td className="text-center">
//                 {it?.fecha_inicio ? moment(it?.fecha_inicio).format('DD-MM-YYYY') : '---'}
//             </td>
//             <td className="text-center"
//                 style={{
//                     color: (moment(it?.fecha_fin).format('YYYY-MM-DD') < moment(new Date()).format('YYYY-MM-DD') && it.estado !== 'completado') ?
//                         'red' : ''
//                 }}>
//                 {it?.fecha_fin ? moment(it?.fecha_fin).format('DD-MM-YYYY') : '---'}{' '}

//                 {/* {it?.fecha_fin ?
//                     `(${moment(it?.fecha_fin).diff(moment(it?.fecha_inicio), 'days') + 1}d)`
//                     :
//                     ''
//                 } */}
//             </td>
//             <td className="text-center"
//                 style={{
//                     color: it?.estado === 'completado' ? 'green' : (it?.estado === 'en proceso' ? '#0F7DFF' : '#FFAD0F'),
//                     textTransform: 'uppercase'
//                 }}>
//                 {it?.estado || '---'}
//             </td>
//             {/* <td className="text-center">
//                 {it?.prioridad === 'critica' ?
//                     <span style={{ color: 'red' }}>{it?.prioridad || '---'}</span>
//                     :
//                     <span>{it?.prioridad || '---'}</span>
//                 }
//             </td> */}
//             <td className="text-start" style={{ verticalAlign: 'middle' }}>
//                 <Tooltip title="Eliminar hito">
//                     <Link to="" onClick={() => handleRemoveTask(it, 'hito')}>
//                         <i className="bi bi-trash" style={{ color: 'gray', fontSize: '14px' }}></i>
//                     </Link>
//                 </Tooltip>
//             </td>
//         </tr>
//     )
// }

const BoxHoras = ({ origen }) => {
    return (
        <div className="ms-4 mt-3">
            <div className="text-[14px]">
                <span className="font-bold">Horas Estimadas:</span>
                <span className="ms-2">{origen?.ppto?.tareas_total_he || 0}h</span>
            </div>

            <div className="text-[14px]">
                <span className="font-bold">Horas Reales:</span>
                <span className="ms-2">{origen?.ppto?.tareas_total_hr || 0}h</span>
            </div>
        </div>
    )
}